/** 翻页书组件全局常量 */
export class BookConstants {
  /** Demo 模式默认页数 */
  static readonly DEFAULT_PAGE_COUNT = 20;
  /** devicePixelRatio 上限，防止高分屏过采样 */
  static readonly MAX_RENDER_RESOLUTION = 3;

  /** 书本外轮廓投影纹理的外扩边距（px） */
  static readonly BOOK_DROP_SHADOW_PADDING = 30;

  /* 翻页动画默认时长（ms） */
  static readonly FLIPPING_TIME = 500;

  /** PDF 页面渲染缩放倍率 */
  static readonly PDF_RENDER_SCALE = 3;

  /** 翻页折痕边缘阴影样式 */
  static readonly FOLD_EDGE_SHADOW_STYLE = {
    color: 0x5a5a5a,
    alpha: 0.2,
    width: 2
  } as const;

  /** 点坐标比较容差（px） */
  static readonly POINT_EPSILON = 0.001;

  /** 几何计算容差（px） */
  static readonly GEOM_EPSILON = 0.001;

  /** 遮罩多边形最小面积（px²） */
  static readonly MIN_MASK_AREA = 1;

  /** 页堆最大线数占页面宽度比例（只封顶线数，不压缩单线宽度） */
  static readonly MAX_THICKNESS_RATIO = 0.02;

  /** 单条厚度线固定宽度（px），与页数无关 */
  static readonly THICKNESS_LINE_WIDTH = 1;

  /** 角落阴影大小占页面短边比例 */
  static readonly CORNER_SHADOW_SIZE_RATIO = 0.78;

  /** 角落阴影最大尺寸（px） */
  static readonly CORNER_SHADOW_MAX_SIZE = 1000;

  /** 悬停预览延迟时长（ms） */
  static readonly HOVER_PREVIEW_DELAY_MS = 80;

  /** 点击翻页后悬停抑制时长（ms） */
  static readonly CLICK_HOVER_SUPPRESS_MS = 100;

  /** 点击 vs 拖拽判定距离阈值（px） */
  static readonly CLICK_FLIP_DISTANCE_PX = 6;

  /** 中央按住起翻的位移阈值（书本坐标 px）：越过后才真正起翻，避免中央轻触误翻页 */
  static readonly MIDDLE_DRAG_ENGAGE_PX = 30;

  /**
   * 中央拖拽折页点距页面上/下边缘的内缩量（书本坐标 px）。
   * 折角计算里 top=0 会使角度退化为 0（纸掀不起、裁剪多边形退化 → 翻起层不显示、闪烁），
   * 故折页点 Y 贴边时保留该内缩，等价于 flipToPage 里 pageHeight-5 的处理。
   */
  static readonly MIDDLE_DRAG_EDGE_INSET_PX = 5;

  /**
   * 中央拖拽起翻时折页从外缘滑入到按下点的过渡动画时长（ms）。
   * 当按下点不在边缘（页面中部起翻）时，折页先从外缘滑入按下点，避免折页瞬间掀起的突兀感。
   */
  static readonly MIDDLE_DRAG_INTRO_MS = 300;

  /**
   * hover 预览起翻时折页从近角滑入到光标点的过渡动画时长（ms）。
   * hover 为轻交互，过渡更短更跟手；避免折页瞬间掀起的突兀感。
   */
  static readonly HOVER_PREVIEW_INTRO_MS = 200;
}
